import { StaticRender } from "./Render";
import { loadImage } from "../utils/utils";
export class StaticImageRender extends StaticRender {
    constructor({ src, width = 0, height = 0, onLoad = null, onLoadStart = null, onLoadEnd = null, onError = null, opacity = 1, offset = [0, 0] }) {
        super();
        this.offset = offset;
        this.onLoad = onLoad;
        this.onLoadStart = onLoadStart;
        this.onLoadEnd = onLoadEnd;
        this.onError = onError;
        this._opacity = opacity;
        this._width = width;
        this._height = height;
        this._src = src;
        this._aborted = false;
        this._complete = false;
        this._createNode();
    }
    _createNode() {
        this._node = new Image();
        if (this._width > 0)
            this._node.width = this._width;
        if (this._height > 0)
            this._node.height = this._height;
        this._node.style.opacity = this._opacity.toString();
        const controller = new AbortController();
        const signal = controller.signal;
        this._controller = controller;
        this.onLoadStart && this.onLoadStart();
        this.readyPromise = loadImage(this._node, this._src, signal);
        this.readyPromise
            .then(() => {
            this._complete = true;
            this.onLoad && this.onLoad();
        })
            .catch((error) => {
            if (this._aborted) {
                return;
            }
            this.onError && this.onError(error);
        })
            .finally(() => {
            this.onLoadEnd && this.onLoadEnd();
        });
    }
    get node() {
        if (this._node)
            return this._node;
        this._createNode();
        return this._node;
    }
    get width() {
        return this._width;
    }
    get height() {
        return this._height;
    }
    // working only for base64 src
    get isReady() {
        return this._node && this._node.complete;
    }
    get error() {
        return (this._node &&
            ((this._node.complete && this._node.src) ||
                (this.isImageLoaded && this._node.parentElement)) &&
            this._node.naturalWidth === 0);
    }
    get opacity() { return parseFloat(this.node.style.opacity); }
    set opacity(value) {
        this._opacity = value;
        if (this.node)
            this.node.style.opacity = value.toString();
    }
    get isImageLoaded() {
        return this._complete;
    }
    deleteNode() {
        this._aborted = true;
        this._controller.abort();
        if (this._node) {
            this._node.src = "";
        }
    }
}
